"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelCollapsible = void 0;
var _react = _interopRequireDefault(require("react"));
var _Panel = _interopRequireDefault(require("react-bootstrap/lib/Panel"));
var _panelCaret = _interopRequireDefault(require("./images/panel-caret.svg"));
var PanelCollapsible = exports.PanelCollapsible = function PanelCollapsible(_ref) {
  var title = _ref.title,
    _ref$withCaret = _ref.withCaret,
    withCaret = _ref$withCaret === void 0 ? false : _ref$withCaret,
    eventKey = _ref.eventKey,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_Panel["default"], {
    className: "panel-collapsible",
    eventKey: eventKey
  }, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Heading, null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Title, {
    toggle: true
  }, title, withCaret && /*#__PURE__*/_react["default"].createElement("img", {
    className: "panel-collapsible__caret",
    src: _panelCaret["default"],
    alt: ""
  }))), /*#__PURE__*/_react["default"].createElement(_Panel["default"].Body, {
    collapsible: true
  }, children));
};